import { render, staticRenderFns } from "./CardDadosPrincipais.vue?vue&type=template&id=713fe662"
import script from "./CardDadosPrincipais.vue?vue&type=script&lang=js"
export * from "./CardDadosPrincipais.vue?vue&type=script&lang=js"
import style0 from "./CardDadosPrincipais.vue?vue&type=style&index=0&id=713fe662&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports